import { Component, Inject } from '@angular/core';
import { PropertyAddFormDialogComponent } from '@client/shared/components/property/property-forms/property-add/property-add-form-dialog/property-add-form-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BankAccount, Loan, LoanPayout, LoanPayoutTypeEnum, LoanService, ToastService } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';

const MESSAGE_SUCCESSFUL_PAY_OUT_LOAN = 'Loan was successfully pay out!';
const MESSAGE_SUCCESSFUL_REFINANCED_LOAN = 'Loan was successfully refinanced!';

interface DialogData {
  bankAccount: BankAccount;
  loan: Loan;
  taxTankBalance: number;
  loanPayoutType?: LoanPayoutTypeEnum;
}

/**
 * Dialog component which contains loan payout form
 */
@Component({
  selector: 'app-loan-payout-dialog',
  templateUrl: './loan-payout-dialog.component.html',
  styleUrls: ['./loan-payout-dialog.component.scss'],
  standalone: false
})
export class LoanPayoutDialogComponent extends BaseComponent {
  payoutTypes = LoanPayoutTypeEnum;

  constructor(
    private loanService: LoanService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<PropertyAddFormDialogComponent>
  ) {
    super();
  }

  /**
   * Add payout loan
   * @param payoutLoan
   */
  addPayoutLoan(payoutLoan: LoanPayout): void {
    this.loanService.addPayoutLoan(this.data.loan, payoutLoan).subscribe(() => {
      this.dialogRef.close();
      this.toastService.success(this.data.loan.payout.isRefinance() ?
        MESSAGE_SUCCESSFUL_REFINANCED_LOAN :
        MESSAGE_SUCCESSFUL_PAY_OUT_LOAN);
    });
  }

  /**
   * Update existing loan payout object
   * @param payoutLoan
   */
  updatePayoutLoan(payoutLoan: LoanPayout): void {
    this.loanService.updatePayoutLoan(this.data.loan, payoutLoan).subscribe(() => {
      this.dialogRef.close();
      this.toastService.success(this.data.loan.payout.isRefinance() ?
        MESSAGE_SUCCESSFUL_REFINANCED_LOAN :
        MESSAGE_SUCCESSFUL_PAY_OUT_LOAN);
    });
  }

  /**
   * Pay out or update payout loan
   * @param paidOutLoan
   */
  submit(paidOutLoan: LoanPayout): void {
    // Set payout loan type
    paidOutLoan.type = this.data.loanPayoutType ?? LoanPayoutTypeEnum.PAYOUT;
    if (this.data.loan.payout) {
      this.updatePayoutLoan(paidOutLoan);
    } else {
      this.addPayoutLoan(paidOutLoan);
    }
  }
}
